var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"list-demo"}},[_c('button',{on:{"click":_vm.add}},[_vm._v("Add")]),_c('button',{on:{"click":_vm.remove}},[_vm._v("Remove")]),_c('transition-group',{attrs:{"name":"list","tag":"p"}},_vm._l((_vm.items),function(item){return _c('span',{key:item,staticClass:"list-item"},[_vm._v(" "+_vm._s(item)+" ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }